export default __webpack_public_path__ + "static/media/ModeIN.fd9cf566.jpg";